export default __webpack_public_path__ + "static/Icon-4a348ecf0d9a5febcd9a0c2f0bc1558d.png";